import { createSlice } from '@reduxjs/toolkit'
import { ApiUrl } from '../constants/api';
import { BackendApi } from '../pages/router-page';

const initialConfigState = {
  inventoryAddress: null,
  policyId: null,
  unitPrice: null,
  nftsToCheck: null,
  blockfrostKey: null,
  blockfrostNetwork: null,
  blockfrostUrl: null,
  contractScript: null
};

export const configSlice = createSlice({
  name: 'config',
  initialState: {
    value: { ...initialConfigState},
  },
  reducers: {
    setConfig: (state, action) => {
      state.value = action.payload;
    }
  },
})

export const setConfigAsync = () => async (dispatch) => {
  try {
    const response = await BackendApi.get(
      `/script/config`,
    );
    dispatch(configSlice.actions.setConfig(response.data));
  } catch (error) {
    console.error('Async operation failed:', error);
  }
};

export const { setConfig } = configSlice.actions

export const selectConfig = (state) => state.config.value

export default configSlice.reducer